import { createAction, props } from "@ngrx/store";
import { ISkillNode } from "@skills-app/models/skillNode";

const prefix = "[Skill Search Bar]";

export const loadComponent = createAction(`${prefix} Load Component`);
export const unloadComponent = createAction(`${prefix} Unload Component`);

export const addSkillToSearch = createAction(
  `${prefix} Add Skill To Search`,
  props<{ skill: ISkillNode }>(),
);

export const addAllSkillsToSearch = createAction(
  `${prefix} Add All Skills To Search`,
  props<{ skills: ISkillNode[] }>(),
);

export const removeSkillFromSearch = createAction(
  `${prefix} Remove Skill From Search`,
  props<{ skill: ISkillNode }>(),
);

export const removeAllSkillsFromSearch = createAction(
  `${prefix} Remove All Skills From Search`,
);

export const changeSkillComboLogic = createAction(
  `${prefix} Change Skill Combo Logic`,
);

export const resetSkillComboLogic = createAction(
  `${prefix} Reset Skill Combo Logic`,
);
